import React, { useState } from "react"
import { CaseManSearchResults } from "../../../../services/caseManService/model/searchResults/CaseManSearchResults"
import { Grid, GridColumn as Column, GridDataStateChangeEvent } from '@progress/kendo-react-grid';
import { process, State } from "@progress/kendo-data-query";
import { ColumnMenu } from "../../../../utils/ColumnMenu";
import { CaseManSearchCommandCell } from "./CaseManSearchCommandCell";

type ownProps = {
    data: CaseManSearchResults[]
}

function CaseManSearchResultsGrid(props:ownProps){
    const [dataState, setDataState] = useState<State>({});
    const mapCases = ():CaseManSearchResults[] => {
        return props.data.map(i => ({...i, serviceDate: new Date(i.serviceDate??'')}))
    }
    const createDataState = (dataState: State) => {
        return {
          dataState: dataState === undefined ? {} :dataState,};
      };
    const dataStateChange = (event: GridDataStateChangeEvent) => {
        let updatedState = createDataState(event.dataState);
        setDataState(updatedState.dataState);
      };

    return <React.Fragment>
        <Grid data={process(mapCases().slice(0),dataState)}{...dataState}
             style={{height:'500px'}} onDataStateChange={dataStateChange}>
                <Column cell={CaseManSearchCommandCell} width={'75px'}/>
                <Column title='Account' field='accountNumber' columnMenu={ColumnMenu}/>
                <Column title='Name' field = 'name' columnMenu={ColumnMenu}/>
                <Column title='Service Date' field="serviceDate" format='{0:MM/dd/yyyy}' columnMenu={ColumnMenu}/>
                <Column title='Coding Review' field='codingReviewStatus' columnMenu={ColumnMenu}/>
                <Column title='Clinical Review' field='clinicalReviewStatus' columnMenu={ColumnMenu}/>
        </Grid>
    </React.Fragment>
}
export {CaseManSearchResultsGrid}